export const ROUTES = {
  CENTER_MAIN_SCREEN: "/center",
  LAUNCHER_CONFIG: "/center/launcherEdit",
  NAVIGATION: "/center/navigation",
  MY_SCREEN: "/center/myScreen",
  MY_SCREEN_CONFIG: "/center/myScreenConfig",
  MEDIA_PLAYER: "/center/mediaplayer",
  GLOBAL_SEARCH: "/center/globalsearch",
  MEDIA_SEARCH: "/center/mediasearch",
  NOTIFICATION_CENTER: "/center/notificationCenter",
  DEVICES: "/center/devices",
  WEATHER: "/center/weather",
  WEATHER_STUTTGART: "/center/weather-stuttgart",
  WEATHER_BERLIN: "/center/weather-berlin",
  WEATHER_SEARCH: "/center/weather-search",
  WEATHER_RAIN: "/center/weather-rain",
  SETTINGS: "/center/settings",
  PHONE: "/center/phone",
  CHARGING: "/center/charging",
  CLIMATE: "/center/climate",
  MAINTENANCE: "/center/maintenance",
  SPORTS_CHRONO: "/center/sport-chrono",
  MESSAGES: "/center/messages",
  UPDATES: "/center/updates",
  HOME_LINK: "/center/homelink",
  CAR: "/center/car",
  NEWS: "/center/news",
  CALENDAR: "/center/calendar",
  ADD_CALENDAR: "/center/add-calendar",
  COCKPIT: "/center/cockpit",
  MY_SCREEN_CONTEXT_OPTIONS: "/center/my-screen-context-options",
  CARPLAY: "/center/carplay",
  ADD_FAVOURITE: "/center/add-favourite",
  NEW_ACCOUNT: "/center/new-account",
  OVERVIEW_PORSCHECONNECTSERVICES: "/center/overview-account-services",
  CONFIGURE_HUD: "/center/configure-hud",
  INFO: "/center/info",
  INFO_IMPRINT: "/center/info-imprint-1",
  INFO_IMPRINT2: "/center/info-imprint-2",
  INFO_DATAPRIVACY: "/center/info-dataprivacy",
  INFO_SOFTWARE: "/center/info-software"
}

export const ROUTES_ANIMATIONS = {
  PAGE_TRANSITION_FADE: "page-transition-fade",
  PAGE_TRANSITION_SLIDE_LEFT: "page-transition-slide-left",
  PAGE_TRANSITION_SLIDE_RIGHT: "page-transition-slide-right"
}
